import { useRef } from 'react';
import '../useSSRLayoutEffect/bb39a440cfd2e66a91ef7db163af56b35e50f0e0f31c4c0e717387eb80740f64.cfe-internal.js';
import useSSRLayoutEffect from '../useSSRLayoutEffect/1b5a8c3b5463c14b01e195c9e403e1d1bbb3a66e0ef365e78fe012b249d635d1.cfe-internal.js';

/**
 * Keeps track of the mounted state of the component.
 * @returns A boolean indicating if the component is mounted.
 */
function useMounted() {
  var mounted = useRef(false);
  useSSRLayoutEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
}

export { useMounted as default };
